import { render, staticRenderFns } from "./SearchOpportunities.vue?vue&type=template&id=beeb4934"
import script from "./SearchOpportunities.vue?vue&type=script&lang=js"
export * from "./SearchOpportunities.vue?vue&type=script&lang=js"
import style0 from "./SearchOpportunities.vue?vue&type=style&index=0&id=beeb4934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports